// Product gallery

jQuery('.m-product__gallery-medium-slides').each(function() { // Allows multiple lightbox galleries per page, if necessary

	jQuery(this).magnificPopup({
		delegate: 'a',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
		},
		mainClass: 'mfp-img-mobile',
		type: 'image'
	});

});